// extracted by mini-css-extract-plugin
module.exports = {"successColor":"#82bc00","active":"UserMFAIcon__active","contentContainer":"UserMFAIcon__contentContainer","icon":"UserMFAIcon__icon"};